import React, { Component, PropType } from 'react'
import * as lib from './Helper';
import { numberComparator, dateComparator, stringComparator} from './ag-gridHelper';
import { isArguments } from 'lodash';
import moment from "moment";


var drillObj = null;
var associateColumnData = [];
var downloadStyle = {
    cursor: 'pointer',
    width: '40px',
    marginTop: '6px'
}
var is_header_size_increase = false;
var sort = [];
var transposeGlobal = false;

class TableDownload extends React.Component {
    constructor(props) {
        super(props);
        this.state = props;
    }
    download = (e) => {
        if (e == "pdf")
            return xepOnline.Formatter.Format(this.state.parentdivID, { render: 'download', srctype: 'svg' });
        if (e == "png")
            return xepOnline.Formatter.Format(this.state.parentdivID, { render: 'newwin', mimeType: 'image/png', resolution: '180', srctype: 'svg' });
    }
    handleChange = (type, e) => {
        var that = this;
        if (e == null) {
            window.location.href = '/dashboard/report';
        }
    }
    downloadCsv() {
        var url = location.search;
        url = url.replace('property', 'selectedProperty');
        url = url.replace('propertyValues', 'selectedPropertyValue');
        url = url.replace('selectedMetric', 'selectedMetric');
        url = url.replace('breakup', 'breakUp');
        url = url.replace('breakup', 'breakUp');
        window.open("/dashboard/report/gettable" + url + "&download=1");
    }
    render() {
        this.state.parentdivID = 'Parent1';
        var showReport = null;
        var saveReport = null;
        var showChart = null;
        var emptyDiv = null;
        var whiteSpace = null;
        var flag = false;
        var editReport = null;
        if (this.state.report) {
            showReport = <a className="" href='/dashboard/savedreport' target='_blank' id="showReports">Show Reports</a>;
            saveReport = <a data-toggle='modal' href='#saveReportPopup' id='saveReport' className=''>Save Report</a>;
            whiteSpace = <div className='col-md-1'></div>;
            flag = true;
        }
        if (this.state.chartEnable) {
            showChart = <a className="" href='/dashboard/realtime?chartCat=Line' target='_blank' id="showReports">Show Chart</a>;
            whiteSpace = <div className='col-md-2'></div>;
            flag = true;
        }
        if (!flag) {
            emptyDiv = <div className='col-md-4'></div>
        }
        if (window.location.pathname.split('/')[2] == 'savedreport')
            var actionButtonStyle = { marginBottom: '12px' };
        else
            var actionButtonStyle = { marginBottom: '12px' };
        return (
            <div className="col-md-12" style={{ padding: "0px" }}>
                <div className="" style={{ position: "relative" }}>
                    <div className='btn-group dropdown pull-right'>
                        <button type="button" className="btn btn-contrast marginStyle fa fa-cloud-download" title='export' id='export' onClick={this.downloadCsv} style={downloadStyle}></button>
                        {/*<button className="btn btn-contrast dropdown-toggle" data-toggle="dropdown" style={actionButtonStyle}>
                            Actions
                            <span className="caret"></span>
                        </button>*/}
                        {/*<ul className="dropdown-menu">
                            <li>{showChart}</li>
                            <li title='Save current view as Report'>{saveReport}</li>
                            <li title='Show saved reports'>{showReport}</li>
                            <li title='Export table content as CSV'><a id="export" href='#' className="">Export</a></li>
                        </ul>*/}
                    </div>
                </div>
            </div>
        );
    }
}

class TableComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = { ...props, messageIndex: 0 };
        // this.adminfunction = this.adminfunction.bind(this);
    }
    componentDidMount() {
        this.createTable(this.state);
        if (this.state.index > 1)
            jQuery('#myGridTop' + this.state.index).height(jQuery('#table' + this.state.index).height() - 90)

        dragcomplete();
    }
    componentDidUpdate() {
        // this.createTable(this.state);
        // if(this.state.index>1)
        //     jQuery('#myGridTop'+this.state.index).height(jQuery('#table'+this.state.index).height()-90)

        dragcomplete();
    }
    componentWillReceiveProps(nextProps) {
        this.createTable(nextProps);
    }
    drillFunction(name, event, value, metric_selected, dateSelected = null) {  // Pass dateSelected for table trend
        if (!name)
            name = "Blanks";
        var valueDemo = [];
        if (event == 'drillAcross') {
            drillObj.map(function (data) {
                if (value == data.value) {
                    valueDemo.obj = data;
                    valueDemo.value = data.value;
                }
            })
        }
        else if (event == 'drillDown') {
            valueDemo = this.state.drillDown;
        }
        else if (event == 'back') {
            valueDemo = '';
        }
        else if (event == 'insight') {
            valueDemo = '';
        }
        else if (event == 'extract') {
            valueDemo = value;
        }
        this.props.drillHandle(name, valueDemo, event, metric_selected, dateSelected);  // Pass dateSelected for table trend
    }

    getContextMenuItems(params) {
        var result = [];
        var temp = [];
        var temp_raw = [];
        // var that = this;
        var raw_data_extract = [{ "label": "Raw Data", "value": "raw" }];
        // var property_disp_count = this.props.propertyDisp ? this.props.propertyDisp.length : 0; // Property label count
        var labelClickedInsight = '';
        var labelClicked = labelClickedInsight = params.node.data.label;
        var metric_selected = params.column.colId;
        var dateSelected = null;
        // if(metric_selected.split(';')[1]!==undefined) {
        //     var metric_selected_split = metric_selected.split(';');
        //     if(property_disp_count == 2) {  // If Property label count is two i.e, cross tab then 2 points will come. Get the second point
        //         labelClickedInsight += ',' + metric_selected_split[2];     // Get the property value clicked    
        //     } else if(this.state.period) {
        //         dateSelected = metric_selected_split[2];
        //     }
        //     metric_selected = metric_selected_split[0] + ";" + metric_selected_split[1];    // Metric selected
        // }
        // else {  
        //     if(transposeGlobal) {   // Case to handle transpose right click
        //         metric_selected = metric_selected == 'label' ? labelClicked : metric_selected;  // Case in transport table when click on metric name metric_selected comes as a 'label' and labelClicked comes as a metric name. So replace 'label' with metric name
        //         let temp = labelClicked;
        //         labelClicked = metric_selected;
        //         metric_selected = temp; 
        //         labelClickedInsight = labelClicked;
        //     } else {
        //         metric_selected = this.props.selectedMetric;
        //     }
        // }
        // this.state.drillAcross.map(function (innerData, index) {
        //     temp.push({
        //         name: innerData.label,
        //         action: that.drillFunction.bind(this, labelClicked, 'drillAcross', innerData.value, metric_selected, dateSelected)
        //     })
        // })
        // raw_data_extract.map(function (innerData, index) {
        //     temp_raw.push({
        //         name: innerData.label,
        //         action: that.rawlogClickHandle.bind(this, labelClicked)
        //     })
        // })
        if (history.length) {
            result.push({
                name: 'Back',
                action: "Action"
                // action: that.drillFunction.bind(this, labelClicked, 'back', '', metric_selected)
            })
        }
        // if (this.state.drillDown.value) {
        //     result.push({
        //         name: 'Drill Down',
        //         action:"Action"
        //         // action: that.drillFunction.bind(this, labelClicked, 'drillDown', this.state.drillDown, metric_selected, dateSelected)
        //     })
        // }
        // result.push({
        //     name: 'Breakdown by',
        //     action: "Action"

        //     // subMenu: temp
        // })
        params.node.setSelected(true)
        var that = this;
        var actionArray = that.props.actionArray;
        result = Object.values(actionArray).map((innerData, i) => {
            let element = {
                name: innerData['label'],
                action: that.props.menuAction(innerData["name"]), 
                // icon: innerData['icon'],
                disabled: innerData['disabledFlag'] ? innerData['disabledFlag'] : false
            }
            let disabledFlag = false;
            if (that.props.restrictOption !== null && that.props.restrictOption !== undefined) {
                disabledFlag = that.props.restrictOption(params.node, innerData);
                element = { name: innerData['label'], disabled: disabledFlag, icon: innerData['icon'], action: innerData['action'] }
            }
            if (innerData['items'] !== null && innerData['items'] !== undefined) {
                element['subMenu'] = Object.values(innerData['items']).map((itemData, j) => {
                    let subDisabledFlag = false;
                    if (that.props.restrictOption !== null && that.props.restrictOption !== undefined) {
                        subDisabledFlag = this.props.restrictOption(params.node, itemData);
                    }
                    let subAction = (itemData['action'] !== null && itemData['action'] !== undefined) ? itemData['action'] : innerData['action'];
        
                    let subElement = {
                        name: itemData['label'],
                        action: (subAction)?.bind(this, itemData['name']),
                        disabled: subDisabledFlag,
                        // icon: itemData['icon']
                    };
        
                    // Handle second-level submenu (subItems)
                    if (itemData['subItems'] !== null && itemData['subItems'] !== undefined) {
                        subElement['subMenu'] = Object.values(itemData['subItems']).map((subItemData, k) => {
                            let subSubDisabledFlag = false;
                            if (that.props.restrictOption !== null && that.props.restrictOption !== undefined) {
                                subSubDisabledFlag = that.props.restrictOption(params.node, subItemData);
                            }
                            let subSubAction = (subItemData['action'] !== null && subItemData['action'] !== undefined) ? subItemData['action'] : subAction;
        
                            return {
                                name: subItemData['label'],
                                action: () => subSubAction(subItemData['name']),
                                disabled: subSubDisabledFlag,
                                // icon: subItemData['icon']
                            };
                        });
                    }
        
                    return subElement;
                });
            }
        
            return element;
        });
        
        // result = Object.values(actionArray).map((innerData, i) => {
        //     let element = {
        //         name: innerData['label'], action: that.props.menuAction(innerData["name"]), icon: innerData['icon'], disabled: innerData['disabledFlag'] ? innerData['disabledFlag'] : false
        //     }
        //     let disabledFlag = false;
        //     if (that.props.restrictOption !== null && that.props.restrictOption !== undefined) {
        //         disabledFlag = that.props.restrictOption(params.node, innerData);
        //         element = { name: innerData['label'], disabled: disabledFlag, icon: innerData['icon'], action: innerData['action'] }
        //     }
        //     if (innerData['items'] !== null && innerData['items'] !== undefined) {
        //         element['subMenu'] = Object.values(innerData['items']).map((itemData, j) => {
        //             // let disabledFlag = that.props.restrictOption(params.node,itemData);
        //             let disabledFlag = false;
        //             if (that.props.restrictOption !== null && that.props.restrictOption !== undefined){
        //                 disabledFlag =  that.props.restrictOption(params.node, itemData);
        //             }
        //             let action = (itemData['action'] !== null && itemData['action'] !== undefined) ? itemData['action'] : innerData['action'];
        //             return { name: itemData['label'], action: (action).bind(this, itemData['name']), disabled: disabledFlag, icon: itemData['icon'] }
        //         })
        //     }
        //     return element;
        // });

        // result.push({
        //     name: 'Clear Selected Rows',
        //     // action:"Clear"
        //     action: that.adminfunction.bind(this,"clear")

        //     // subMenu: temp
        // })

        // result.push({
        //     name: 'Edit',
        //     action: that.props.handleMenuAction.bind(this, "bulk")
        //     // action: that.adminfunction.bind(this, "bulk")

        //     // subMenu: temp
        // })


        // result.push({
        //     name: 'Auto Analysis',
        //     action: "Action"

        //     // action: that.drillFunction.bind(this, labelClickedInsight, 'insight', '', metric_selected, dateSelected)
        // })
        // if(extract_data && extract_data!=="0")
        //     result.push({
        //         name: 'Extract',
        //         action: "Action"

        //         // subMenu: temp_raw
        //     })
        // else console.log('no ok');
        if(this.props.firstColumnField!='reportName'){
        result.push('copyWithHeaders')
        }
        return result;
    }

    rawlogClickHandle(value) {
        jQuery('#download_property').val(value);
        jQuery('#download_handle').modal('toggle')
    }

    createTable(reactObj) {
        var that = this;
        let mobile = jQuery(document).width() < mobile_width || jQuery(document).width() < tablet_width 
        transposeGlobal = that.props.transpose;
        transposeGlobal = transposeGlobal == 'true' ? true : false;
        var propertyDisp = reactObj.propertyDisp;
        var selectedProperty = reactObj.selectedProperty;
        if (allDateColumns) {
            var allDateColumnsArray = allDateColumns.split(',');
            var selectedPropertyArray = selectedProperty ? selectedProperty.split(',') : null;
            if (selectedPropertyArray) {
                var tempCommonElements = _.intersection(allDateColumnsArray, selectedPropertyArray);
                if (tempCommonElements.length) {
                    propertyDisp.map(function (val, index) {
                        tempCommonElements.map(function (val1, index1) {
                            if (val['value'].split(',').indexOf(val1) > -1)
                                dateColumnsToConsider.push(val['label']);
                        });
                    });
                }
            }
        }
        is_header_size_increase = false
        if (reactObj.tablerendered === false) {
            return true;
        }
        var divId = '#myGridTop';
        if (reactObj.index) {
            divId += reactObj.index;
        }
        jQuery(divId).empty();
        var labelName = this.state.label ? this.state.label : 'Label';
        var drillDown = reactObj.drillDown;
        var showTotalRow = reactObj.sum != null ? true : false;
        var setWidth = reactObj.setWidth ? true : false;
        var width = reactObj.width ? reactObj.width : null;
        var mainColumnDef = [];
        if (metricGlobal.length > 0)
            var property_width = metricGlobal[0].property_width;
        else property_width = null;
        if (reactObj.transpose === false) {
            if (reactObj.data.propertyHeaders && reactObj.selectedMetric.split(',').length == 1) {
                var temp_metric_label = refineData(reactObj.selectedMetric, metricGlobal, metricFunction);
                labelName = temp_metric_label.label + " by " + labelName;
                is_header_size_increase = true
            }
        }
        if (reactObj.firstColumnShow != false) {

            var firstColumnRender = (reactObj.firstCellRender !== null && reactObj.firstCellRender !== undefined) ? reactObj.firstCellRender : null;

            var columnDef = [{
                headerName: labelName,
                field: reactObj.firstColumnField,
                // width: property_width?parseInt(property_width):null,
                minWidth: 50,
                tooltipField: reactObj.firstColumnField,
                // tooltipField: "tooltip",
                // width:100,
                maxWidth: 250,
                pinned: mobile ? false : true,
                custom_editable: reactObj.firstCellEdit ? reactObj.firstCellEdit : false,
                checkboxSelection: reactObj.selectbox ? reactObj.selectbox : false,
                headerCheckboxSelection: reactObj.headerSelectBox ? reactObj.headerSelectBox : false,
                // cellStyle: {
                //     'background-color': "#90ee90"
                // },
                cellClass: "ag-cell-class",
                sortingOrder: ['asc', 'desc'],
                filter: "agTextColumnFilter",
                // cellRenderer: dateFormatter,
                cellRenderer: firstColumnRender,
                // cellRenderer: function (params) {
                //     // put the value in bold
                //     // <div>
                //     //     <span>Hello world</span>
                //     //     <i className="float-right fas fa-check-circle" style={{ color: "#90ee90" }}></i>
                //     // </div>
                //     let htmlString = `<span>${params.value}<i class="fas fa-check-circle mg-t-2 float-right" style='color:#90ee90'></i></span>`;
                //     return htmlString;
                //     // return 'Value is <b>' + params.value + '</b>';
                // },
                comparator: stringComparator,
                // enableRowGroup:true,
                // enablePivot:true,
                unSortIcon: true // to show sort on column which are not sorted
            },];
        } else var columnDef = [];
        if (this.state.link && this.state.pop) {
            columnDef[0].cellRenderer = function (params) {
                if (params.data.pop)
                    var value = "<a data-html='true' class='btn-link has-popover' data-content='" + params.data.pop + "' href='" + params.data.link + "' target='_blank' data-placement='right' data-title='Information' data-original-title style='cusron:pointer'>" + params.data.label + "</a>";
                else var value = "<a class='btn-link' href='" + params.data.link + "' target='_blank' style='cusron:pointer'>" + params.data.label + "</a>";
                return value;
            }
        }
        else if (this.state.link) {
            columnDef[0].cellRenderer = function (params) {
                let onClickEvent = params.data.eventFunc ? params.data.eventFunc : null
                let hrefLink = params.data.link ? params.data.link : null
                var value = "<a class='btn-link' href='" + hrefLink + "' target='_self' style='cusron:pointer' onClick='" + onClickEvent + "'>" + params.data.label + "</a>";
                return value;
            }
        }
        else if (this.state.pop) {
            columnDef[0].cellRenderer = function (params) {
                if (params.data.pop)
                    var value = "<a data-html='true' class='btn-link has-popover' data-content='" + params.data.pop + "' data-placement='right' data-title='Information' data-original-title style='cusron:pointer'>" + params.data.label + "</a>";
                else var value = params.data.label;
                return value;
            }
        }
        var associateThis = this;
        metricFunction = reactObj.noMetricFunction ? [] : metricFunction
        if (labelName.toLowerCase() == "label" || reactObj.report === true)
            var metricsObject = createCombination(reactObj.metrics, metricFunction);
        else var metricsObject = reactObj.metrics;
        mainColumnDef = columnDef;
        columnDef = [];
        if (reactObj.data.data != null) {
            var shareVariable = '_ROCKMETRICSHARE';
            var selectedMetric = reactObj.selectedMetric;
            var isSort = reactObj.sort ? reactObj.sort : true;
            var sortOrder = reactObj.sortOrder ? reactObj.sortOrder : 'desc';
            var sortMetric = reactObj.sortMetric ? reactObj.sortMetric : null;
            var tempMetric = '';
            // if(!sortMetric){
            //     if (selectedMetric)
            //         tempMetric = selectedMetric.split(',')[0];
            //     jQuery(metricsObject).each(function (index, val) {
            //         if (val.value == tempMetric) {
            //             sortMetric = val.value;
            //             return false;
            //         }
            //     });
            // }
            var temp = [];
            // var shareMetric = [];
            if (selectedMetric) {
                temp = selectedMetric.split(',');
            }
            // var shareData = reactObj.data.data[0];
            // if(shareData){
            //     Object.keys(shareData).forEach(function(key) {
            //         if(key && key.indexOf(shareVariable) !== -1)
            //             temp.push(key);
            //     });
            // }
            var newMetricObject = [];
            if (lastRowFunction && transposeGlobal != true && (window.location.pathname == "/dashboard/report" || window.location.pathname == "/dashboard/dashboard")) {
                var selectedMetricArray = this.props.selectedMetric.split(',');
                switch (lastRowFunction) {
                    case 'avg':
                    case 'mean':
                        lastRowFunction = 'Average';
                        break;
                    case 'sum':
                        lastRowFunction = 'Sum';
                        break;
                    case 'min':
                        lastRowFunction = 'Min';
                        break;
                    case 'max':
                        lastRowFunction = 'Max';
                        break;
                }
                var lastRowMetric = [];
                var appearedMetrics = [];
            }
            var propertyHeaders = reactObj.data.propertyHeaders;
            if (reactObj.data && reactObj.data.propertyHeaders && reactObj.data.propertyHeaders.length) {
                jQuery(reactObj.data.propertyHeaders).each(function (index, propLabel) {
                    var tempMetricObject = [];
                    jQuery(metricsObject).each(function (index, val) {
                        if (jQuery.inArray(val.value, temp) > -1) {
                            // var tempIndex = jQuery.inArray(val.value, temp);
                            var tempArrayObject = JSON.parse(JSON.stringify(val));
                            // var newVal = jQuery.extend(true, {}, tempArrayObject);
                            tempArrayObject.label = tempArrayObject.label + ";" + propLabel;
                            tempArrayObject.value = tempArrayObject.value + ";" + propLabel;
                            // tempArrayObject.showShare = "false";
                            tempMetricObject[jQuery.inArray(val.value, temp)] = tempArrayObject;
                            if (lastRowFunction && transposeGlobal != true && propertyHeaders.length > last_row_function_min_month) {    // Create Average Row metric
                                var lastRowFunctionUpdated = lastRowFunction + ' Row';
                                var localVal = tempArrayObject.value.split(';');
                                localVal = localVal[0] + ';' + localVal[1];
                                if (!(jQuery.inArray(localVal, appearedMetrics) > -1)) {
                                    var newVal = jQuery.extend(true, {}, tempArrayObject);
                                    var label = newVal.label;
                                    var labelSplit = label.split(';');    // Total List Price;2016    // Replace 2016 with Function Name and remove Ttal
                                    label = label.replace(labelSplit[1], lastRowFunctionUpdated);    // Replace 20176 with 'lastRowFunction Row'
                                    var newLabel = label.split(' ');
                                    if (newVal['isDerived'] == '0')   // Remove 2nd word i.e, metricFunction (Total, Sum, Avg etc.) only for base metric
                                        newLabel.splice(0, 1);  // Remove Total
                                    newVal.label = newLabel.join(' '); // new Label
                                    var tempValue = newVal.value.split(';');
                                    var tempValueLength = tempValue.length;
                                    tempValue[tempValueLength - 1] = lastRowFunctionUpdated;
                                    newVal.value = tempValue.join(';');
                                    lastRowMetric[jQuery.inArray(localVal, selectedMetricArray)] = newVal;
                                    appearedMetrics.push(localVal);
                                }
                            }
                            // newMetricObject.push(tempArrayObject);
                            // if(val.defaultFormula)
                            //     var newMet = smallFirstLetter(tempArrayObject.value) + shareVariable;
                            // else 
                            // var newMet = tempArrayObject.value + shareVariable;
                            // if(jQuery.inArray(newMet, temp) > -1) {
                            //     newVal.label = newVal.label + ' (% Share)' +";"+ propLabel;
                            //     newVal.value = newMet;
                            //     newVal.metricPrefix = false;
                            //     newVal.metricUnit = '%';
                            //     newVal.numberShorten = 'in';
                            //     newVal.showShare = "true";
                            //     temp.splice(tempIndex, 0, newMet);
                            //     tempMetricObject.splice(tempIndex, 0, tempArrayObject);
                            //     tempMetricObject[tempIndex+1]=newVal;
                            // }
                        }
                    });
                    newMetricObject = newMetricObject.concat(tempMetricObject);
                });
            }
            else {
                jQuery(metricsObject).each(function (index, val) {
                    if (jQuery.inArray(val.value, temp) > -1) {
                        var tempIndex = jQuery.inArray(val.value, temp);
                        // val.showShare = "false";
                        newMetricObject[tempIndex] = val;
                        // if(val.defaultFormula)
                        //     var newMet = smallFirstLetter(val.value) + shareVariable;
                        // else 
                        // var newMet = val.value + shareVariable;
                        // if(jQuery.inArray(newMet, temp) > -1) {
                        //     var newVal = jQuery.extend(true, {}, val);
                        //     newVal.label = val.label + ' (% Share)';
                        //     newVal.value = newMet;
                        //     newVal.metricPrefix = false;
                        //     newVal.metricUnit = '%';
                        //     newVal.numberShorten = 'in';
                        //     newVal.showShare = "true";
                        //     temp.splice(tempIndex, 0, newMet);
                        //     newMetricObject.splice(tempIndex, 0, val);
                        //     newMetricObject[tempIndex+1]=newVal;
                        // }
                    }
                    // else {
                    //     var fullMet = val.defaultFormula + ' ' + val.label;
                    //     var newMet = fullMet + shareVariable;
                    //     if(jQuery.inArray(newMet, temp) > -1) {
                    //         val.label = ucwords(fullMet) + ' (% Share)';
                    //         val.value = newMet;
                    //         val.metricPrefix = false;
                    //         val.metricUnit = '%';
                    //         val.numberShorten = 'in';
                    //         val.showShare = "true";
                    //         newMetricObject[jQuery.inArray(newMet, temp)]=val;
                    //     }
                    // }
                });
            }
            if (lastRowFunction && transposeGlobal != true && this.props.period) {
                newMetricObject = jQuery.merge(newMetricObject, lastRowMetric);
            }
            if (labelName.toLowerCase() == "label" || reactObj.report === true)
                metricsObject = newMetricObject.length ? newMetricObject : metricsObject;
            var labelTemp = null;
            var insert = false;
            var period = this.props.period;

            // Commented the case. Check for which case this case was used
            // if(reactObj.propertyDisp && transposeGlobal){
            //     // metricsObject.push({"label":"Label 1",value:"label1"});
            //     metricsObject=[{"label":"Label 1",value:"label1",type:"string"}].concat(metricsObject);
            //     transposeGlobal=false;
            // }

            jQuery.each(metricsObject, function (index, val) {
                if (val) {
                    var information = val.information ? val.information : null;

                    if (val.associateColumn) {
                        var temp = [];
                        temp['associateColumn'] = val.associateColumn;
                        temp['isColor'] = val.isColor;
                        temp['isPercent'] = val.isPercent;
                        temp['roundOff'] = val.roundOff;
                        associateColumnData[val.value] = temp;
                    }
                    var obj = {};
                    var condition = val.sort != 'null' && val.sort != 'NULL' && val.sort;
                    if (condition) {
                        sort = [
                            { colId: val.value, sort: val.sortOrder }
                        ];
                        isSort = false;
                    } else {
                        if (isSort) {
                            sort = [
                                { colId: sortMetric, sort: sortOrder }
                            ];
                            isSort = false;
                        }
                    }
                    var append = '';
                    var $append = '';
                    var prefix = '';
                    var $prefix = '';
                    var roundOff = 0;
                    var $roundOff = 0;
                    var color = false;
                    var showShare = val.showShare;
                    showShare = showShare == 'false' || !showShare ? false : true;
                    if (val.metricUnit != null && val.metricUnit != '') {
                        append = val.metricUnit;
                        color = val.color ? true : false;
                        $append = append;
                        prefix = val.metricPrefix;
                        $prefix = prefix;
                        roundOff = val.roundOff;
                        $roundOff = parseInt(roundOff);
                    }
                    else {
                        roundOff = val.roundOff;
                        $roundOff = parseInt(roundOff);
                    }
                    var $numberShorten = val.numberShorten;
                    var label = val.label ? val.label.split(';') : val.label;
                    var labelVal = val.value ? val.value.split(';') : val.value;
                    // if(labelVal[2] && labelVal[2].indexOf('_') > -1) {
                    //     label[0] = labelVal[0];
                    //     label[2] = labelVal[2].split('_')[0];
                    // }
                    if (reactObj.selectedMetric) {
                        if (reactObj.selectedMetric.split(',').length > 1) {
                            if (label[1] != labelTemp && labelTemp) {
                                if (mainColumnDef.length) {
                                    mainColumnDef.push({ headerName: "<b>" + labelTemp + "<b>", marryChildren: true, children: columnDef });
                                } else {
                                    mainColumnDef = columnDef;
                                }
                                columnDef = [];
                            }
                        } else label = [label[1] ? label[1] : label[0]];
                    } else label = label ? [label[1] ? label[1] : label[0]] : ['Blanks']; // To handle the case in tranpose when 1st label is null
                    labelTemp = label ? label[1] : ['Blanks'];
                    label = labelVal ? (labelVal[1] && labelVal[1].indexOf('_') > -1 ? val.label : label[0]) : ['Blanks'];
                    var suppressFilter = false;
                    var filter;
                    var filterParams;
                    var comparatorVal;
                    var cellStyle;
                    if (val.label == 'Date Time' || val.label == 'DateTime' || val.label == 'Date Modified') {
                        filter = 'date';
                        filterParams = {};
                        filterParams.comparator = function (filterLocalDateAtMidnight, cellValue) {
                            var dateAsString = cellValue;
                            var dateParts = dateAsString.split("-");
                            var timeParts = (dateParts[3].trim()).split(":");
                            var cellDate = new Date(Number(dateParts[0]), Number(dateParts[1]), Number(dateParts[2]), Number(timeParts[0]), Number(timeParts[1]), Number(timeParts[2]));

                            if (filterLocalDateAtMidnight.getTime() == cellDate.getTime()) {
                                return 0
                            }

                            if (cellDate < filterLocalDateAtMidnight) {
                                return -1;
                            }

                            if (cellDate > filterLocalDateAtMidnight) {
                                return 1;
                            }
                        };
                        suppressFilter = true;
                    }
                    else {
                        filter = val.type == undefined || val.type == 'order' || val.type == 'number' || val.type == '1' || val.type == '2' ? 'number' : val.type;
                        filterParams = null;
                    }
                    // console.log(val.value)
                    // if(val.value="last_updated_time"){
                    //     comparatorVal = momentDateComparator
                    // }
                    // console.log(val)
                    if (val.label == 'Date Time' || val.label == 'Date Modified' || val.type == "datetime" || val.label =="Last Updated Timestamp" 
                    // || val.label == "Size"
                    ) {
                        if(val.label =="Last Updated Timestamp"){
                            comparatorVal = momentDateComparator
                        }
                        // else if(val.label=="Size"){
                        //     console.log(val.label)
                        //     comparatorVal = sortSizeData
                        // }
                        else{
                        comparatorVal = dateComparator;
                        }
                    }
                    else {
                        comparatorVal = filter == 'number' ? numberComparator : stringComparator;
                    }
                    if (filter == 'number') {
                        cellStyle = { 'text-align': 'right', 'padding-right': '2px' };
                        filter = "agNumberColumnFilter";
                    }
                    else {
                        cellStyle = { 'padding-left': '2px' };
                        filter = 'agTextColumnFilter';
                    }
                    if (val.width && val.width < 150 && is_header_size_increase === false)
                        is_header_size_increase = true;
                    var column_width = val.width ? parseInt(val.width) : null;

                    // if(val.defaultFormula)
                    //     var field_value=val.label.charAt(0).toLowerCase() + val.label.slice(1);
                    // else var field_value=val.label;
                    if (val.child && reactObj.index == -100) {
                        label = label + "<br><a class='fa fa-level-down' onclick=table_drill_handle(\'" + val.child.trim() + "\')></a>";
                        // is_header_size_increase=true;
                    }
                    // cellStyle = jQuery.extend(cellStyle, { "border-right": 'solid 1px #bdc3c8' });

                    if (val.type == "html") {
                        // cellStyle = { "border-right": 'solid 1px #bdc3c8' };
                        cellStyle = { ...cellStyle, ...val.cellStyle }
                    }

                    let cellEditorParams = null;
                    let cellEditor = null;
                    let editable = false;

                    if (val.dropdown_value) {
                        if (typeof (val.dropdown_value) == "object") {

                            cellEditorParams = function (params) {
                                // let allowedValue = [];
                                // let notAllowedValue = [];
                                // let finalResult = null;

                                if (params.data.isDisabled!=undefined){

                                    let final_values = [];

                                    val.dropdown_value.filter((element)=>{
                                        if(element.isDisabled==params.data.isDisabled)
                                            final_values.push(element.name)
                                    });

                                    return {values: final_values};
                                }
                                else{
                                    return {values: val.dropdown_value}
                                }
                                // return { values: params.node.data[`${params.colDef.field}Array`] }
                                // return { values: val.dropdown_value }


                                // let status = params.data.status;
                                // let allowedValue = val.dropdown_value[status];
                                // return { values : allowedValue}
                            }
                        } else {
                            cellEditorParams = {
                                values: val.dropdown_value
                            }
                        }
                        cellEditor = 'agRichSelectCellEditor';
                    }

                    if (val.cellEditor) {
                        cellEditor = val.cellEditor;
                    }

                    if (val.editable) {
                        editable = val.editable;
                    }

                    if (val.cellEditor == "agLargeTextCellEditor") {
                        cellEditorParams = {
                            maxLength: 2000
                        }
                    }
                    if (val.dataType == 'number') {
                        cellStyle = { "text-align": "right" }
                    }
                    else if (val.dataType == 'string') {
                        cellStyle = { "text-align": "left" }
                    }
                    // Conditional Formatting                    
                    var cellStyleFinal = function(params) {
                        if(information){
                            let newStyle = handleConditionalFormatting(params.value, information, 'rockmetric_raw_data', cellStyle);
                            return newStyle
                        }return cellStyle
                    };
                    obj = {
                        headerName: label,
                        field: val.value,
                        colId: val.value,
                        // width: column_width,
                        minWidth: 50,
                        maxWidth: 300,
                        cellStyle: {...cellStyleFinal, borderRight:"solid 1px #bdc3c8"},
                        cellClass: "ag-cell-class",
                        filter: val.filter ? val.filter : "agTextColumnFilter",
                        hide: val.hide,
                        pinned: val.pinned ? val.pinned : false,
                        custom_editable: editable,
                        cellEditor: cellEditor,
                        cellEditorParams: cellEditorParams,
                        suppressFilter: suppressFilter,
                        comparator: comparatorVal,
                        sortingOrder: ['asc', 'desc'],
                        enableValue: filter === 'number' ? true : false,
                        cellRenderer: function (params) {
                            var percentile = false;
                            var mainLabel = params.column.colDef.field;
                            if (!params.data) {
                                return;
                            }
                            var value = params.data[mainLabel];
                            if (value && mainLabel) {
                                value = mainLabel && mainLabel == 'frequency' || mainLabel=='isSubscribed'
                                    ? reactObj.iconDisplay(params)
                                    : ['timestamp', 'lastPulledDate', 'date', 'last_updated_time', 'dateModified', 'createdBy'].indexOf(mainLabel) > -1
                                        ? `${moment(value).format('Do MMMM YYYY')} (IST)`
                                        : mainLabel == 'type'
                                            ? value.charAt(0).toUpperCase() + value.slice(1)
                                            : value
                            }
                            if (mainLabel && mainLabel.indexOf("percentile") > 1) {
                                $roundOff = 2;
                                $numberShorten = "in";
                                // $append="% ile";
                                $prefix = "false";
                                var percentile = true;
                            }
                            // Prevent Cross Site Scripting
                            if (['formula', 'seconLevelFormula', 'formulae'].indexOf(mainLabel) > -1) {
                                let checkValidity = true
                                // if (refineURLData(value) && ['name','label','value','formula', 'formulae', 'seconLevelFormula'].indexOf(mainLabel) !== -1) {
                                checkValidity = checkSpecialChars(value, 'formula') ? false : true
                                if (checkValidity && refineURLData(value)) {
                                    checkValidity = ['=', '+', '-', '@'].indexOf(value.charAt(0)) > -1 ? false : true
                                }
                                // }
                                if (!checkValidity) value = '-'
                            }
                            if (params.data['label'] === "Total") {
                                if (mainLabel.indexOf("percentile") > 1) {
                                    value = "N.A";    // Show N.A. in Total Row
                                    $roundOff = 2;
                                    $numberShorten = "in";
                                    $append = "";
                                    $prefix = "none";
                                } else if (mainLabel.indexOf('_growth') > 1) {
                                    value = 'N.A.';
                                }
                                else if (lastRowFunction && transposeGlobal != true) {
                                    var splitMainLabel = mainLabel.split(';');
                                    var mainLabelLanght = splitMainLabel.length - 1;
                                    if (splitMainLabel[mainLabelLanght] == lastRowFunction + ' Row') {
                                        // value="N.A";    // Show N.A. in Total Row
                                        value = isNaN(value.replace(/,/g, "")) ? 'N.A.' : value;
                                    }
                                }
                            }
                            if (transposeGlobal == 'true' || transposeGlobal == true) {
                                var label = params.data['label'];
                                var metIndex = getIndexOfMetric(label);
                                if (metIndex == -1) {
                                    $roundOff = 2;
                                    $numberShorten = "in";
                                    $append = "";
                                    $prefix = "none";
                                } else {
                                    var transposeMetricArray = metricGlobal[metIndex];
                                    $roundOff = transposeMetricArray['roundOff'];
                                    $numberShorten = transposeMetricArray['numberShorten'];
                                    $prefix = transposeMetricArray['metricPrefix'];
                                    $append = transposeMetricArray['metricUnit'];
                                }
                                var percentile = label ? (label.split(' ')[0] == 'Percentile' ? true : false) : false;
                            }
                            if (!value) {
                                mainLabel = params.column.colDef.colId;
                                value = params.data[mainLabel];
                                if (!value) {
                                    // value=is_null_to_zero=='TRUE'?0:"-";
                                    value = value == 0 ? 0 : "-";
                                }
                            }
                            // var shareLabel = mainLabel + '_ROCKMETRICSHARE';
                            // if(period && period.toLowerCase() != 'aggregate' && mainLabel) {
                            //     shareLabel = mainLabel.split(';');
                            //     shareLabel = shareLabel[0] + '_ROCKMETRICSHARE' + ';' + shareLabel[1];
                            // } 
                            // var shareValue = params.data[shareLabel];
                            // value = (value == undefined || value == '') && params.data['label']!='Total' ? 0 : value;
                            var shareValue = '';
                            var realValue = value;
                            if ((value || value == 0) && typeof value != 'string' && value !== undefined) {
                                // shareValue = shareValue == undefined || shareValue == '' ? '' : ' (' + number_shorten(shareValue.toString(),2) + '%)';//to show percentage share
                                value = value == undefined || value == '' ? lib.number_shorten('0', $roundOff, $numberShorten) : lib.number_shorten(value.toString(), $roundOff, $numberShorten);
                            }
                            if (showShare) {
                                // booleanProperty specifies whether Total row should show 'N.A.' for '% Share' metric or not
                                // If there is/are property value/s or more than one property then Total should show 'N.A.' 
                                var booleanProperty = associateThis.state.data.property && ((associateThis.state.data.property.indexOf(';') > -1) || (associateThis.state.data.property.indexOf(',') > -1)) ? true : false;
                                if (params.data['label'] == 'Total') {
                                    if (booleanProperty || (lastRowFunction && transposeGlobal != true)) {
                                        // Remove comma from value if it contains and then check if it is number of not 
                                        value = isNaN(value.replace(/,/g, "")) ? 'N.A.' : value;    // Check if value if number then show 100 otherwise N.A.. This case is only for % share
                                    }
                                    else if (value != 'N.A.')
                                        value = lib.number_shorten('100', 2);
                                }
                                // else value = value == undefined || value == '' ? 'N.A.' : value; 
                                else value = value == undefined || value == '' ? '0.00' : value;
                            }
                            else value = value == undefined || value == '' ? '-' : value;
                            var $newAppend = $append;
                            if (value == 'N.A.' || value == '-') {
                                $newAppend = '';
                            }
                            if (associateColumnData[mainLabel]) {
                                value = associateThis.getAssociateColumnData(params.data, value, mainLabel);
                            }
                            var signUsed = '';
                            var floatValue = parseFloat(realValue);
                            if (percentile) {
                                color = true;
                                var colorUsed = '';
                                var signUsed = '';
                                if (floatValue >= 0) {
                                    signUsed = '';
                                    if (floatValue <= 20) {
                                        value = 'Top 20%';
                                        colorUsed = 'DarkGreen';
                                    }
                                    else if (floatValue <= 40) {
                                        value = 'Top 40%';
                                        colorUsed = 'Lime';
                                    }
                                    else if (floatValue <= 60) {
                                        value = 'Top 60%';
                                        colorUsed = '#caca0e';
                                    }
                                } else {
                                    if (!isNaN(floatValue)) {
                                        if (floatValue <= -40) {
                                            value = 'Bottom 40%';
                                            colorUsed = 'LightPink';
                                        }
                                        else if (floatValue <= -20) {
                                            value = 'Bottom 20%';
                                            colorUsed = 'Red'
                                        }
                                    }
                                }
                            } else {
                                if (floatValue >= 0) {
                                    var colorUsed = 'green';
                                    var signUsed = '+';
                                    color = false;
                                } else {
                                    if (!isNaN(floatValue)) {
                                        var colorUsed = 'red';
                                        var signUsed = '';
                                        color = true;
                                    }
                                }
                            }


                            // put the value in bold

                            // if($newAppend==="%"){
                            //     colorUsed=realValue>=75?"green":"red";
                            //     color=true;
                            // }
                            var paddingRight = "padding-right:5px";
                            if ($prefix == 'true')
                                return '<span class="rag-element" style="' + paddingRight + '">' + $newAppend + ' ' + value + '' + shareValue + '</span>';
                            if (color)
                                return '<span class="rag-element" style="color:' + colorUsed + ';' + paddingRight + '>' + signUsed + '' + value + ' ' + $newAppend + '' + shareValue + '<span>';
                            return '<span class="rag-element" style="' + paddingRight + '">' + value + ' ' + $newAppend + '' + shareValue + '</span>';


                        },
                        unSortIcon: true  // to show sort on column which are not sorted
                    }
                    columnDef.push(obj);
                    if (selectedMetric) {
                        var metricArray = selectedMetric.split(',');
                        var flag = false;
                        metricArray.forEach(function (metricValue, index) {
                            if (metricValue == val.value) {
                                flag = true;
                                return false
                            }
                        });
                        if (!flag)
                            obj.hide = false;
                    }
                }
            });
        }

        /* Start Code for Button in Ag-grid Cells */

        if (reactObj.buttonColumnArray) {
            reactObj.buttonColumnArray.map(function (innerData) {
                columnDef.push({
                    headerName: innerData.label,
                    minWidth: 175,
                    cellRenderer:getBtnCellRenderer(reactObj.buttonColumnArray),
                    cellRendererParams: {
                        clicked: innerData.onClick
                    },
                })
            })
        }

        /* End Code for Button in Ag-grid Cells */

        if (mainColumnDef.length) {
            if (labelTemp)
                mainColumnDef.push({ headerName: "<b>" + labelTemp + "<b>", marryChildren: true, children: columnDef });
            else mainColumnDef = mainColumnDef.concat(columnDef);
        } else {
            mainColumnDef = columnDef;
        }
        var height_auto = null;
        var ag_header_height = 35;
        var ag_header_height_double = 50;
        // if(reactObj.index==1){
        //     height_auto='autoHeight';
        //     var maxHeight=479-ag_header_height;
        //     if(is_header_size_increase)
        //         var maxHeight=479-(ag_header_height_double);
        //     if(reactObj.data.propertyHeaders && selectedMetric.split(',').length>1){
        //         var maxHeight=479-(ag_header_height_double);
        //         if(is_header_size_increase)
        //             var maxHeight=479-(ag_header_height+ag_header_height_double);
        //     }
        //     if(showTotalRow)
        //         maxHeight=maxHeight-30;
        //     setTimeout(function(){
        //         jQuery('.ag-row-animation').css("max-height",maxHeight);
        //     },1000);
        // }
        var enableSorting = transposeGlobal ? false : true;
        // console.log("reactObj.data",reactObj.data);
        var largeData = reactObj.data.data.length > 2000 ? true : false;
        var defaultColDef = { resizable: true, sortable: true, wrapText: true, autoHeight: true, editable: reactObj.edit ? reactObj.edit : false, filter: 'agTextColumnFilter'};
        let loadingMessage = reactObj?.loadingMessage ? reactObj?.loadingMessage : 'No Data Found!' 
        // var defaultColDef = { editable: reactObj.edit ? reactObj.edit : false };

        // if(window.location.pathname=="/dashboard/dashboard" && disable_table_filter=="TRUE"){
        //     defaultColDef={
        //         menuTabs:[]
        //     };
        //     enableSorting=false;
        // }
        gridOptions = {
            columnDefs: mainColumnDef,
            defaultColDef: defaultColDef,
            rowData: null,
            onCellContextMenu: function (params) {
                setTimeout(() => {
                        params.api.deselectAll(); // Clear previous selection
                        params.node.setSelected(true); // Select the clicked row
                }, 100);
            },
        
            // Ensure selection is cleared on click
            onCellClicked: function (params) {
                params.api.deselectAll(); // Clear previous selection
                params.node.setSelected(true); // Select the clicked row
            },
            pagination: reactObj.pagination ? reactObj.pagination : false,
            paginationPageSize: reactObj.rowsPerPage ? reactObj.rowsPerPage : 15,
            enableSorting: enableSorting,
            singleClickEdit: true,
            enableCellChangeFlash: true,
            suppressCellSelection: true,
            enterMovesDown:true,
            enterMovesDownAfterEdit:true,
            onGridReady: this.onGridReady,
            onColumnResized: this.onColumnResized,
            onCellDoubleClicked: onCellDoubleClickedHandler,
            overlayLoadingTemplate: reactObj?.noRowsAvailable == true
                ? '<span style="padding: 10px;">' + loadingMessage + '</span>'
                : '<span className="ag-overlay-loading-center">Please wait while your rows are loading..</span>',
            // overlayLoadingTemplate: '<span className="ag-overlay-loading-center">Please wait while your rows are loading</span>'
            // deltaRowDataMode:true,
            // rowSelection: 'multiple',
            // statusBar: {
            //     statusPanels: [
            //         // { statusPanel: 'agTotalAndFilteredRowCountComponent', align: 'right' },
            //         { statusPanel: 'agTotalRowCountComponent', align: 'right' },

            //     ]
            // },
            enableFilter: true,
            debug: false,
            enableColResize: true,
            // getRowStyle: function (params) {
            //     if (params.node.floating) {
            //         return { 'font-weight': 'bold' }
            //     }
            // },
            // editType : 'fullRow',
            // getRowStyle: function (params) {
            //     return { 'backgroundColor': '#90ee90' }

            // },
            // getRowStyle: reactObj.handleRowStyle ? reactObj.handleRowStyle: null,
            // getRowClass: reactObj.handleRowStyle ? reactObj.handleRowStyle : null,
            // rowClass:'my-green-class',

            // domLayout: height_auto,
            rowModelType: largeData ? 'infinite' : '',

            //suppressMenuMainPanel: true,//menuTabs=['filterMenuTab','columnsMenuTab']
            //suppressMenuColumnPanel: true,//menuTabs=['generalMenuTab','filterMenuTab']
            // headerHeight: is_header_size_increase?(ag_header_height_double):(ag_header_height),
            animateRows: true,
            enableRangeSelection: true,
            rowSelection: this.props.rowSelection,
            rowDeselection: true,
            suppressCellSelection: true,
            sideBar: {
                toolPanels: [{
                    id: 'columns',
                    labelDefault: 'Columns',
                    labelKey: 'columns',
                    iconKey: 'columns',
                    toolPanel: 'agColumnsToolPanel',
                    toolPanelParams: {
                        suppressRowGroups: true,
                        suppressValues: true,
                        suppressPivots: true,
                        suppressPivotMode: true,
                        suppressSideButtons: true,
                        suppressColumnFilter: true,
                        suppressColumnSelectAll: true,
                        suppressColumnExpandAll: true
                    }
                }],
                defaultToolPanel: 'columns'
            },
            clipboardDeliminator: ',',
            floatingFilter: !reactObj.noFilters,
            onSortChanged: function (e) {
                if (largeData) {
                    if (gridOptions.api.getSortModel() != 0) {
                        var sortMetric = gridOptions.api.getSortModel()[0].colId;
                        var sortOrder = gridOptions.api.getSortModel()[0].sort;
                        if ((reactObj.sortOrder != sortOrder && sort[0].sort != sortOrder) || (reactObj.sortMetric != sortMetric && sort[0].colId != sortMetric)) {
                            that.setState({
                                sort: true,
                                sortOrder: sortOrder,
                                sortMetric: sortMetric,
                                data: {
                                    data: reactObj.data.data,
                                    metric: reactObj.data.metric,
                                    property: reactObj.data.property,
                                    propertyHeaders: reactObj.data.propertyHeaders
                                }
                            })
                            that.createTable(that.state);
                        }
                    }
                }
                e.api.deselectAll();  // Clears all selected rows
            },
            onCellEditingStopped: reactObj.onCellChange ? reactObj.onCellChange : null,
            // onRowDataChanged:()=>{alert('hello')},
            // onRowDataUpdated:()=>{alert('hello')},
            // onShouldRowBeSkipped: reactObj.exportFile ? reactObj.exportFile :null,
            // onRowSelected: reactObj.onRowSelect ? reactObj.onRowSelect:null,
            // onSelectionChanged: reactObj.onRowSelect ? reactObj.onRowSelect:null,
            onFilterModified: function () { gridOptions.api.setPinnedBottomRowData() },
            components: {
                datePicker: getDatePicker(),
                btnCellRenderer: getBtnCellRenderer(reactObj.buttonColumnArray)
            },
            // paginationPageSize: 50,
            // pagination: reactObj.pagination
        };
        if (showTotalRow !== false) {
            gridOptions['pinnedBottomRowData'] = [];
        }

        if (reactObj.drillAcross && reactObj.index == 1) {
            drillObj = reactObj.drillAcross;
            gridOptions['getContextMenuItems'] = this.getContextMenuItems.bind(this);
        }
        var bottomData;
        var eGridDiv = document.querySelector(divId);
        new agGrid.Grid(eGridDiv, gridOptions);
        if (showTotalRow !== false) {
            // if (reactObj.sum[0]) {
            //     if (reactObj.sum[0].label != 'all')
            //         bottomData = [refineTotalData(reactObj.sum, metricsObject)];
            //     else {
            //         reactObj.sum[0].label = 'Total';
            //         bottomData = reactObj.sum;
            //     }
            // }
            // else 
            bottomData = [refineTotalData(reactObj.sum, metricsObject, reactObj.period)];
            gridOptions.api.setPinnedBottomRowData(bottomData);
        }
        gridOptions.api.closeToolPanel();
        if (enableSorting)
            gridOptions.api.setSortModel(sort);
        if (setWidth)
            gridOptions.api.sizeColumnsToFit();
        
            
        function onCellDoubleClickedHandler(event) {
            console.log(event)
            if (event.column.colId === 'name') {
                that.props.openDatasetOnDoubleClick();
            }
        }
        
        function sortAndFilter(allOfTheData, sortModel, filterModel) {
            return sortData(sortModel, filterData(filterModel, allOfTheData));
        }
        // function sortSizeData(a,b){
        //     // let a="4.55 GB"
        //     let tempA = a.split(" ");
        //     if(tempA[1]=="GB"){
        //         tempA[0] = (tempA[0].trim() * 1024);
        //     }
        //     // console.log(tempA)
        //     let tempB = b.split(" ");
        //     if(tempB[1]=="GB"){
        //         tempB[0] = (tempB[0].trim() * 1024);
        //     }
        //     // console.log(tempB)
        //     const sizeA = tempA[0];
        //     const sizeB =tempB[0];
            
        //     console.log(sizeA  +"-" + sizeB)
        //     return sizeA > sizeB ? 1 : sizeA < sizeB ? -1 : 0;
        //     // return sizeA - sizeB;
        // }
        function momentDateComparator(a, b) {
            // console.log("memeo")
            return moment(a, 'Do MMMM YYYY').diff(moment(b, 'Do MMMM YYYY'));
        }
        function sortData(sortModel, data) {
            var sortPresent = sortModel && sortModel.length > 0;
            if (!sortPresent) {
                return data;
            }
            // do an in memory sort of the data, across all the fields
            var resultOfSort = data.slice();
            // console.log(data)
            // console.log(resultOfSort)
            resultOfSort.sort(function (a, b) {
                for (var k = 0; k < sortModel.length; k++) {

                    var sortColModel = sortModel[k];
                    var valueA = a[sortColModel.colId];
                    var valueB = b[sortColModel.colId];
                    // this filter didn't find a difference, move onto the next one
                    if (valueA == valueB) {
                        continue;
                    }
                    var sortDirection = sortColModel.sort === 'asc' ? 1 : -1;
                    if (valueA > valueB) {
                        return sortDirection;
                    } else {
                        return sortDirection * -1;
                    }
                }
                // no filters found a difference
                return 0;
            });
            return resultOfSort;
        }

        function filterData(filterModel, data) {
            var filterPresent = filterModel && Object.keys(filterModel).length > 0;
            if (!filterPresent) {
                return data;
            }
            let columns = Object.keys(data[0]);

            var resultOfFilter = [];
            for (var i = 0; i < data.length; i++) {
                var item = data[i];

                for (var j = 0; j < columns.length; j++) {
                    let val = item[columns[j]]
                    let filterVal = filterModel[value].filter
                    let filterType = filterModel[value].type
                    let type = typeof val;
                    switch (type) {
                        case 'number':
                            filterVal = parseFloat(filterVal)
                            switch (filterType) {
                                case 'equal':
                                    if (val != filterVal) continue;
                                    break;
                                case 'lessThan':
                                    if (val >= filterVal) continue;
                                    break;
                                default:
                                    if (val <= filterVal) continue;
                                    break;

                            }
                            break;
                        case 'string':
                            if (filterVal.values.indexOf(val) < 0)
                                continue;
                            break;
                        case 'date':
                            break;
                    }
                };
                resultOfFilter.push(item);
                // if (filterModel.age) {
                //     var age = item.age;
                //     var allowedAge = parseInt(filterModel.age.filter);
                //     // EQUALS = 1;
                //     // LESS_THAN = 2;
                //     // GREATER_THAN = 3;
                //     if (filterModel.age.type == 'equals') {
                //         if (age !== allowedAge) {
                //             continue;
                //         }
                //     } else if (filterModel.age.type == 'lessThan') {
                //         if (age >= allowedAge) {
                //             continue;
                //         }
                //     } else {
                //         if (age <= allowedAge) {
                //             continue;
                //         }
                //     }
                // }

                // if (filterModel.year) {
                //     if (filterModel.year.values.indexOf(item.year.toString()) < 0) {
                //         // year didn't match, so skip this record
                //         continue;
                //     }
                // }

                // if (filterModel.country) {
                //     if (filterModel.country.values.indexOf(item.country) < 0) {
                //         continue;
                //     }
                // }

                // resultOfFilter.push(item);
            }

            return resultOfFilter;
        }

        if (largeData) {  // Data preparation for CellRenderer
            // if (sort) {
            //     var columnName = sort[0].colId;
            //     var columnSort = sort[0].sort;
            //     if (columnName && columnSort)
            //         var new_data = reactObj.data.data.sort(GetSortOrder(columnName, columnSort));
            //     var new_data = reactObj.data.data;
            // } else var new_data = reactObj.data.data;

            // var mockServer = new MockServer();
            // mockServer.init(new_data);
            // var viewportDatasource = new ViewportDatasource(mockServer);
            // gridOptions.api.setViewportDatasource(viewportDatasource);
            let largeVolumeData = reactObj.data.data
            var dataSource = {
                rowCount: null, // behave as infinite scroll
                getRows: function (params) {
                    setTimeout(function () {
                        var dataAfterSortingAndFiltering = sortAndFilter(
                            largeVolumeData,
                            params.sortModel,
                            params.filterModel
                        );
                        var rowsThisPage = dataAfterSortingAndFiltering.slice(
                            params.startRow,
                            params.endRow
                        );
                        var lastRow = -1;
                        if (dataAfterSortingAndFiltering.length <= params.endRow) {
                            lastRow = dataAfterSortingAndFiltering.length;
                        }
                        params.successCallback(rowsThisPage, lastRow);
                    }, 500);
                },
            };
            gridOptions.api.setDatasource(dataSource);


        } else if (reactObj.data.data.length > 0) {
            gridOptions.api.setRowData(reactObj.data.data);
        } else gridOptions.api.showLoadingOverlay();

        jQuery("#toolPanel").unbind('click').click(function () { // unbind any previous click on toolPanel button because it was getting called twice on a single click
    if (gridOptions.api.isToolPanelShowing()) {
                _paq.push(['trackEvent', 'Edit', 'Report', 'Clicked']);
                gridOptions.api.closeToolPanel()
                // jQuery(this).html("Edit Report");
                // jQuery(divId).width("100%");
            }
            else {
                // jQuery(this).html("Hide Edit Report");
                gridOptions.api.openToolPanel("columns");
                // gridOptions.api.showToolPanel(true);
            }
        });
        gridOptions.columnApi.sizeColumnsToFit(50);//This is done because it initially it is not visiable thats y it is been fixed first then gets updated to autofit
        var allColumnIds = [];
        gridOptions.columnApi.getAllColumns().forEach(function (column) {
            allColumnIds.push(column.colId);
        });
        gridOptions.columnApi.autoSizeAllColumns(allColumnIds);
        // jQuery(".ag-header-cell-label,.ag-header-group-cell-label").css("color","black");
        // jQuery(".ag-header-cell-label,.ag-header-group-cell-label").css("font-weight","bold");
        // jQuery(".ag-header-cell-label,.ag-header-group-cell-label").css("justify-content","center");
        // jQuery("#export").click(function () {
        //     _paq.push(['trackEvent', 'Export', 'Report', 'Success']);
        //     var userFileName = 'Report.csv';
        //     var params = {
        //         fileName: userFileName
        //     };
        //     gridOptions.api.exportDataAsCsv(params);
        // });
    }

   
    onGridReady(params) {
        // Calculate the maximum length of column names
        // const headerCells = document.querySelectorAll('.ag-header-cell-text');
        //     let minHeight = 25;
        //     headerCells.forEach(cell => {
        //         minHeight = Math.max(minHeight, cell.scrollHeight);

        //     });
        //     params.api.setHeaderHeight(minHeight+10);
        //     // params.api.resetRowHeights();
        const headerCells = document.querySelectorAll('[role="columnheader"]');
        const headerGroupCells = document.querySelectorAll('.ag-header-group-text');
        // Loop through each header and apply the tooltip

        headerCells.forEach(cell => {
            // Get the tooltip content from the `title` attribute of the header
            const tooltipText = cell.innerHTML;

            // Add `data-toggle` and `data-placement` attributes for Bootstrap 4 tooltip
            if (tooltipText) {
                cell.setAttribute('data-toggle', 'tooltip');
                cell.setAttribute('data-placement', 'top');
                cell.setAttribute('title', tooltipText);
                cell.style.marginTop = '3px';

                // Initialize Bootstrap 4 Tooltip on this element
                $(cell).tooltip();  // Bootstrap 4 initialization
            }
        });
        headerGroupCells.forEach(cell => {
            // Get the tooltip content from the `title` attribute of the header
            const tooltipText = cell.innerHTML;

            // Add `data-toggle` and `data-placement` attributes for Bootstrap 4 tooltip
            if (tooltipText) {
                cell.style.marginTop = '3px';
                cell.setAttribute('data-toggle', 'tooltip');
                cell.setAttribute('data-placement', 'top');
                cell.setAttribute('title', tooltipText);

                // Initialize Bootstrap 4 Tooltip on this element
                $(cell).tooltip();  // Bootstrap 4 initialization
            }
        });
        // if (window.location.pathname === "/pinboard") {
        //     const element = document.querySelectorAll('.ag-icon.ag-icon-none');
        //     element.forEach(element => {
        //       element.style.marginTop = '-8px';
        //     });
        //   }
        

    }
    onColumnResized(params) {
        const MIN_HEIGHT = 30;
        if (params.finished !== false) {
            params.api.setHeaderHeight(MIN_HEIGHT);
            const headerCells = document.querySelectorAll('.ag-header-cell-text');
            const headerIcons = document.querySelectorAll('.ag-icon-none');
            let minHeight = MIN_HEIGHT;
            headerCells.forEach(cell => {
                minHeight = Math.max(minHeight, cell.scrollHeight);
            });
            headerIcons.forEach((cell) => {
                cell.classList.add('ag-headerIconsMarginTopAdminPanel')
            })
            params.api.setHeaderHeight(minHeight+10);
            params.api.resetRowHeights();
        }
    }
    getAssociateColumnData(data, mainValue, mainLabel) {
        var columnData = associateColumnData[mainLabel];
        var value = data[columnData['associateColumn']];
        var color = columnData['isColor'] == 'true';
        if (color) {
            if (parseFloat(value) > 0) {
                var colorUsed = 'green';
                var signUsed = '+';
            } else {
                var colorUsed = 'red';
                var signUsed = '';
            }
        }
        value = columnData['isPercent'] == 'true' ? '(' + signUsed + '' + value + ' %)' : ' (' + value + ')';
        if (color)
            return mainValue + ' <span style="color:' + colorUsed + '">' + value + '<span>';
        else
            return mainValue + value;
    }
    downloadHandle(e) {
        e.preventDefault();
        this.drillFunction(jQuery('#download_property').val(), 'extract', jQuery('#download_pin').val())
    }
    render() {
        setTimeout(function () {
            var allColumnIds = [];
            gridOptions.columnApi.getAllColumns().forEach(function (column) {
                allColumnIds.push(column.colId);
            });

            // if (allColumnIds.length !== 5) {
            //     allColumnIds = allColumnIds.slice(0, 5);
            // }
            // gridOptions.columnApi.autoSizeAllColumns(allColumnIds);
            // gridOptions.api.sizeColumnsToFit(allColumnIds);

            gridOptions.columnApi.autoSizeAllColumns(allColumnIds);
            dragcomplete();
        }, 1000);
        if (this.state.index)
            var id = 'myGridTop' + this.state.index;
        else var id = 'myGridTop';
        var tableHeight = this.state.tableHeight ? this.state.tableHeight : '450px';
        // var tableHeight = this.state.index == 1 ? { minHeight: "150px", height: tableHeight, width: "100%" } : { minHeight: "150px", maxHeight: tableHeight, width: "100%" }
        if(this.state.index == 1) {
            let localStyle = { minHeight: "150px", height: tableHeight, width: "100%" }
            tableHeight = {...localStyle, ...this.props.tableStyle }
        } else {
            tableHeight = { minHeight: "150px", maxHeight: tableHeight, width: "100%" }
        }
        return (
            <span>
                <div className="modal fade modal-wide" id="download_handle" style={{}}>
                    <div className="modal-dialog">
                        <div className="modal-content" style={{ textAlign: "left" }}>
                            <div className="modal-header">
                                <button aria-hidden="true" className="close" data-dismiss="modal" type="button">Ã—</button>
                                <h5 className="modal-title" id="alertData">Download Details</h5>
                            </div>
                            <div className="modal-body" style={{ overflow: 'auto' }}>
                                <form autoComplete='off' className="form" style={{ marginBottom: '0px' }} onSubmit={this.downloadHandle.bind(this)}>
                                    <div className="form-group">
                                        <label htmlFor="title_pin">Download Title</label>
                                        <input className="form-control" id="download_pin" placeholder="Download Title" type="text" required />
                                        <input className="form-control" id="download_property" type="hidden" required />
                                    </div>
                                    <button className="btn btn-default marginStyle" data-dismiss="modal" id="popupClose" >Close</button>
                                    <button id="save_download_Button" className="btn btn-contrast marginStyle" type="submit">Done</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div className=''>
                    <div id={id} className="ag-theme-balham" style={tableHeight}></div>
                </div>
                {/* <div className='tableDownloadComponent col-md-12'>
                    <TableDownload report={this.state.report} chartEnable={this.state.chartEnable} savedReportList={this.state.savedReportList} />
                </div> */}
            </span>
        );
    }
}

function clickEvent(e, type) {
    var callFunction = mainObj.drillHandle(e.innerHTML, type);
}

function ucwords(str) {
    return (str + '').replace(/^([a-z])|\s+([a-z])/g, function ($1) {
        return $1.toUpperCase();
    });
}

function smallFirstLetter(string) {
    return string.charAt(0).toLowerCase() + string.slice(1);
}

function getIndexOfMetric(label) {
    var newLabel = label.split(' ');
    newLabel.splice(0, 1);
    newLabel = newLabel.join(' ');
    var metricColumns = metricGlobal.getColumn('label');
    var index = metricColumns.indexOf(newLabel);
    return index == -1 ? metricColumns.indexOf(label) : index;
}

checkSpecialChars = (str, string = null) => {
    var format = null
    if (string === 'formula') {
        format = /[~!@#$^\[\]{};\\|<>?]+/                               //for formulae
    } else if(string === 'metricLabel'){
        format = /[~!@#$^*()\=\[\]{};':"\\|,.<>\/?]+/                   //for metric labels
    } else if (string == 'propertyLabel'){
        format = /[~!@#$%^*()\=\[\]{};':"\\|,.<>\/?]+/                  //for property labels
    } else if(string === 'password') {
        format = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]).{8,}$/
        str = str.trim()                                                //for password
    } else if(string === 'number') {
        format = /^[0-9]+$/                                             //for only numeric
    } else if(string === 'pinInsert') {
        format = /[~!@#$^&*+\=\[\]{};':"\\|.<>\/?]+/
    } else {
        format = /[~!@#$%^&*()+\=\[\]{};':"\\|,.<>\/?]+/
    }
    if (format.test(str)) {
        return true;
    } else {
        return false;
    }
}

function refineURLData(value) {
    var paramsToCheck = [undefined, 'undefined', null, 'null']
    return paramsToCheck.indexOf(value) != -1 ? '' : value;
}

function getDatePicker() {
    // function to act as a class
    function Datepicker() { }

    // gets called once before the renderer is used
    Datepicker.prototype.init = function (params) {
        // create the cell
        this.eInput = document.createElement('input');
        this.eInput.value = params.value;

        // https://jqueryui.com/datepicker/
        $(this.eInput).datepicker({
            language: 'en',
            dateFormat: 'dd/mm/yy'
        });
    };

    // gets called once when grid ready to insert the element
    Datepicker.prototype.getGui = function () {
        return this.eInput;
    };

    // focus and select can be done after the gui is attached
    Datepicker.prototype.afterGuiAttached = function () {
        this.eInput.focus();
        this.eInput.select();
    };

    // returns the new value after editing
    Datepicker.prototype.getValue = function () {
        return this.eInput.value;
    };

    // any cleanup we need to be done here
    Datepicker.prototype.destroy = function () {
        // but this example is simple, no cleanup, we could
        // even leave this method out as it's optional
    };

    // if true, then this editor will appear in a popup
    Datepicker.prototype.isPopup = function () {
        // and we could leave this method out also, false is the default
        return false;
    };

    return Datepicker;
}

function getBtnCellRenderer(buttonColumnArray) {
    function BtnCellRenderer() { }

    BtnCellRenderer.prototype.init = function (params) {
        this.params = params;
        if (this.params.data) {
            this.eGui = this.params.data.reportStatus == null || this.params.data.reportStatus == 'not-requested' || this.params.data.reportStatus == 'requested'? document.createElement('button') : document.createElement('div');
                this.params.data.reportStatus=='requested' || this.params.data.componentType!='adhoc-report' ? this.eGui.disabled = true : false
            if (this.params.data.reportStatus == 'requested') {
                buttonColumnArray[0].value = 'In Progress'
            } else {
                buttonColumnArray[0].value = 'Request Report'
            }
            this.eGui.innerHTML = this.params.data.reportStatus == null || this.params.data.reportStatus == 'not-requested' || this.params.data.reportStatus == 'requested' ? buttonColumnArray[0].value :
                `<span>
                 <i class="fas fa-check-circle mg-t-2 mg-t-5" style="color:#04cc82;font-size:20px;position:relative;left:40%"></i>
                  </span>`;
            this.eGui.className = this.params.data.componentType!='adhoc-report'? 'disabledButtonStyle' :  this.params.data.reportStatus == null || this.params.data.reportStatus == 'not-requested'  && buttonColumnArray[0].value == 'Request Report' ?
                'requestButtonStyle' : this.params.data.reportStatus == 'requested' && buttonColumnArray[0].value == 'In Progress' ? 'progressButtonStyle' : this.params.data.reportStatus == 'generated'  ? ''  : 'disabledButtonStyle'
            this.btnClickedHandler = this.btnClickedHandler.bind(this);
            this.params.data.reportStatus == null || this.params.data.reportStatus == 'not-requested' ? this.eGui.addEventListener('click', this.btnClickedHandler) : null;
        }

    }
    BtnCellRenderer.prototype.getGui = function () {
        return this.eGui;
    }
    //commented due to causing error infinite scrolling
    // BtnCellRenderer.prototype.destroy = function () {
    //     this.eGui.removeEventListener('click', this.btnClickedHandler);
    // }

    BtnCellRenderer.prototype.btnClickedHandler = function (event) {
        const params = {
            event: event,
            rowData: this.params.node.data
        }
        this.params.clicked(params);
    }
    return BtnCellRenderer;
}

export default TableComponent;